import { useState } from "react";

export default function Documents() {

  const [search, setSearch] = useState("");

  /* ===============================
     SAMPLE DATA (REPLACE LATER)
  =============================== */
  const documents = [
    {
      name: "Client Agreement.pdf",
      type: "PDF",
      date: "2026-04-01",
      status: "Active",
    },
    {
      name: "Marketing Plan.docx",
      type: "DOCX",
      date: "2026-03-28",
      status: "Archived",
    },
    {
      name: "Financial Report.xlsx",
      type: "XLSX",
      date: "2026-03-25",
      status: "Active",
    },
  ];

  /* ===============================
     FILTER
  =============================== */
  const filteredDocs = documents.filter((doc) =>
    doc.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-6">

      {/* ===============================
         HEADER
      =============================== */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-3xl font-bold">Documents</h2>
          <p className="text-gray-500">
            Manage and organize your files
          </p>
        </div>

        <button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition">
          Upload Document
        </button>
      </div>

      {/* ===============================
         SEARCH
      =============================== */}
      <div className="bg-white p-4 rounded-xl shadow-sm border">
        <input
          type="text"
          placeholder="Search documents..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      {/* ===============================
         TABLE
      =============================== */}
      <div className="bg-white rounded-xl shadow-sm border overflow-x-auto">
        <table className="w-full text-sm">

          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="p-4">File Name</th>
              <th className="p-4">Type</th>
              <th className="p-4">Date</th>
              <th className="p-4">Status</th>
              <th className="p-4">Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredDocs.length > 0 ? (
              filteredDocs.map((doc, i) => (
                <tr key={i} className="border-t hover:bg-gray-50">

                  <td className="p-4 font-medium">{doc.name}</td>
                  <td className="p-4">{doc.type}</td>
                  <td className="p-4">{doc.date}</td>

                  {/* Status */}
                  <td className="p-4">
                    <span
                      className={`px-2 py-1 text-xs rounded-full ${
                        doc.status === "Active"
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-200 text-gray-600"
                      }`}
                    >
                      {doc.status}
                    </span>
                  </td>

                  {/* Actions */}
                  <td className="p-4 space-x-2">
                    <button className="text-blue-600 hover:underline">
                      View
                    </button>
                    <button className="text-green-600 hover:underline">
                      Download
                    </button>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="p-6 text-center text-gray-500">
                  No documents found
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

    </div>
  );
}